import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/navigation";
import { useTranslation } from "hooks/useTranslation";
import styles from "./index.module.css";

interface Props {
  locale: string;
  onLogout: () => void;
}

export default function ProfileDropdown({ locale, onLogout }: Props) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const t = useTranslation();

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const goToProfile = () => {
    setOpen(false);
    router.push(`/${locale}/profile`);
  };

  return (
    <div className={styles.profileDropdown} ref={dropdownRef}>
      {/* PROFILE ICON */}
      <div
        className={styles.profileIcon}
        title={t("header.profile")}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        {/* SVG ICON */}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>

      {/* DROPDOWN */}
      {open && (
        <div className={styles.dropdownMenu}>
          <button className={styles.dropdownItem} onClick={goToProfile}>
            <i className={`user-icon ${styles.icon}`}></i>
            <span>{t("profile.profile")}</span>
          </button>
          <button
            className={`${styles.dropdownItem} ${styles.danger}`}
            onClick={onLogout}
          >
            <i className={`logout-icon ${styles.icon}`}></i>
            <span>{t("profile.signOut")}</span>
          </button>
        </div>
      )}
    </div>
  );
}
